import React from 'react'
import PropTypes from 'prop-types'
import TrackableContext from './TrackableContext'
import axios from 'axios'
import snakeCaseKeys from 'snakecase-keys'

class TrackableSection extends React.Component {
  constructor (props) {
    super(props)

    this.requests = {}
    this.trackOnUnload = true

    this.updateTrackingObject = this.updateTrackingObject.bind(this)
    this.getTrackedVal = this.getTrackedVal.bind(this)
    this.sendTrackedInfo = this.sendTrackedInfo.bind(this)
    this.handleBeforeUnload = this.handleBeforeUnload.bind(this)
  }

  componentDidMount () {
    if (!this.props.disable) {
      window.addEventListener('beforeunload', this.handleBeforeUnload)
    }
  }

  componentWillUnmount () {
    if (!this.props.disable) {
      window.removeEventListener('beforeunload', this.handleBeforeUnload)
    }
  }

  handleBeforeUnload () {
    if (this.props.onBeforeUnload) {
      this.props.onBeforeUnload(this.updateTrackingObject)
    }

    this.sendTrackedInfo()
  }

  sendTrackedInfo () {
    let requests = []
    for (const key in this.requests) {
      if (!this.props.disabledEvents.includes(key)) {
        requests = requests.concat(this.getTrackedVal(key))
        delete this.requests[key]
      }
    }

    if (requests.length > 0) {
      const requestObj = {
        ops: requests,
        sequential: true
      }
      axios.post('/batch', snakeCaseKeys(requestObj))
    }
  }

  updateTrackingObject (name, params) {
    const currentTrackedInfo = this.getTrackedVal(name)

    const url = params.url || this.props.defaultUrl
    const method = params.method || this.props.defaultMethod

    const requestObj = {
      params: {
        ...this.props.globalParams,
        ...params
      },
      url: `${this.props.urlPrefix}${url}`,
      method
    }
    const updatedParams = currentTrackedInfo
      ? [...currentTrackedInfo, requestObj]
      : [requestObj]

    this.requests[name] = updatedParams
  }

  getTrackedVal (key) {
    return this.requests[key]
  }

  render () {
    return (
      <TrackableContext.Provider
        value={{
          update: this.updateTrackingObject,
          get: this.getTrackedVal,
          trackManually: this.sendTrackedInfo
        }}
      >
        {this.props.children}
      </TrackableContext.Provider>
    )
  }
}

TrackableSection.defaultProps = {
  urlPrefix: '/',
  defaultMethod: 'post'
}

TrackableSection.propTypes = {
  children: PropTypes.node,
  urlPrefix: PropTypes.string,
  onBeforeUnload: PropTypes.func,
  defaultUrl: PropTypes.string,
  defaultMethod: PropTypes.string,
  globalParams: PropTypes.object,
  disable: PropTypes.bool,
  disabledEvents: PropTypes.array
}

export default TrackableSection
